import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PosCreditRequestCompanyBankingReferencesModalComponent } from './pos-credit-request-company-banking-references-modal.component';
import { PosCreditRequestCompanyBankingReferencesModalService } from 'src/app/@core/services/pos-credit-request-company-banking-references-modal.service';
import { NgxMaskModule } from 'ngx-mask';
import { ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { RequiredAsteriskModule } from 'src/app/@core/directives/required-asterisk/required-asterisk.module';



@NgModule({
  declarations: [PosCreditRequestCompanyBankingReferencesModalComponent],
  imports: [
    CommonModule,
    NgxMaskModule,
    ReactiveFormsModule,
    NgSelectModule,
    BsDatepickerModule,
    RequiredAsteriskModule
  ],
  providers: [PosCreditRequestCompanyBankingReferencesModalService],
  exports: [PosCreditRequestCompanyBankingReferencesModalComponent]
})
export class PosCreditRequestCompanyBankingReferencesModalModule { }
